module.exports = __webpack_public_path__ + "static/img/11.f00e260.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/zh/11.png
// module id = epgz
// module chunks = 0